module.exports = __webpack_public_path__ + "static/media/logo-hal.8914ec8e.png";